import dayjs from 'dayjs'

const emailTemplate = (
  state,
  firstDate,
  totals,
  zohoinvoicenumber,
  zohoState
) => {
  const plantName = state?.data?.plantName || 'Unknown Plant'
  const invoiceMonth = dayjs(firstDate).format('MMMM YYYY')
  const invoiceCode = zohoinvoicenumber 
  const clientName = state?.data?.clientDetails?.clientName ||
    state?.data?.clientDetails?.contactName ||
    'Valued Customer'

  const senderName =
    (zohoState && zohoState.organizationName) || 'DE Solar Assets Series 2 LLP'

  return `
    <div style="font-family: Arial, sans-serif; font-size: 16px; color: #333;">
      <div style="text-align: center; padding: 20px; background-color: #f5f5f5;">
        <img src="https://i.ibb.co/BTKxrRX/Group-2317.png" alt="Logo" style="max-width: 150px;" />
        <h2 style="color: #092259;">Invoice ${invoiceCode}</h2>
      </div>

      <p>Dear ${clientName},</p>
      <p>
        Please find attached the invoice for <strong>${plantName}</strong> for ${invoiceMonth}.
      </p>

      <table style="width: 100%; border-collapse: collapse; margin: 20px 0;">
        <tr>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Invoice No</th>
          <td style="border: 1px solid #ddd; padding: 8px;">${invoiceCode}</td>
        </tr>
        <tr>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Invoice Date</th>
          <td style="border: 1px solid #ddd; padding: 8px;">${dayjs(
            firstDate
          ).format('YYYY-MM-DD')}</td>
        </tr>
        <tr>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Total Amount</th>
          <td style="border: 1px solid #ddd; padding: 8px; font-weight: bold; color: #d9534f;">₹${Math.round(
            totals?.totalAmount || 0
          )}</td>
        </tr>
      </table>

      <p>Regards,</p>
      <p>${senderName}</p>
    </div>
  `
}

export default emailTemplate
